module.exports = __webpack_public_path__ + "static/media/valentino.3810856f.jpg";